import { Box } from '@wix/design-system';
import React, { FC } from 'react';

import { HelpCenterArticle } from '../../types';
import { ResolutionStatusTag } from './ResolutionStatusTag';

export interface FeatureRequestStatusProps {
  article: HelpCenterArticle;
}

export const FeatureRequestStatus: FC<FeatureRequestStatusProps> = ({ article }) => {
  return (
    <Box gap="SP1">
      <ResolutionStatusTag article={article} />
    </Box>
  );
};
